export default __webpack_public_path__ + "b9b0e3b69f264f364a1df0ceb70094f4.ogg";